window.formatInputData = function () {
    $('.card input, select').each(function () {
        if ($(this).attr('type') === 'checkbox' && $(this).is(':checked')) {
            return true;
        }
        if ($(this).attr('type') !== 'checkbox' && $(this).val() !== '') {
            return true;
        }
        $(this).prop('disabled', true);
    });
}
